const API_FAILSAFE_MESSAGE =
  "Наидовме на проблем, пробајте повторно подоцна.";

let lastNoticeAt = 0;

export function ensureOkResponse(response, fallbackMessage = API_FAILSAFE_MESSAGE) {
  if (!response || !response.ok) {
    throw new Error(fallbackMessage);
  }
  return response;
}

export function handleApiFailureRedirect(navigate, error) {
  console.error("API failsafe redirect:", error);

  const now = Date.now();
  if (now - lastNoticeAt > 1500) {
    lastNoticeAt = now;
    window.alert(API_FAILSAFE_MESSAGE);
  }

  navigate("/", { replace: true });
}

